import { CHCCountdown } from "./countdown.component.js";
customElements.define("chc-countdown", CHCCountdown);
export {
  CHCCountdown
};
//# sourceMappingURL=countdown.js.map
